import { HomeComponent } from "./home.container";

export default HomeComponent;
